import router from '../router'
import * as api from './api'

export const clearAllData = (state) => {
  state.commit('clearAllData')
}

export const toggleDialog = (store, params) => {
  store.commit('isLayerOpened', params.isLayerOpened)
}

// Used to pass through the VueX logic
export const post = (store, params) => {
  return api.post(params)
    .then((res) => {
      // Place a global hook here
      return res
    })
    .catch((err) => {
      // Place a gobal handler here

      // Redirect to login
      if (err.status === 403 || err.status === 401) {
        router.push({ name: 'Login' })
      }

      throw err
    })
}

export const get = (store, params) => {
  return api.get(params)
    .then((res) => {
      // Place a global hook here
      return res
    })
    .catch((err) => {
      // Place a gobal handler here

      // Redirect to login
      if (err.status === 403 || err.status === 401) {
        router.push({ name: 'Login' })
      }

      throw err
    })
}

export const getWithOpts = (store, params) => {
  return api.getWithOpts(params)
    .then((res) => {
      // Place a global hook here
      return res
    })
    .catch((err) => {
      // Place a gobal handler here

      // Redirect to login
      if (err.status === 403 || err.status === 401) {
        router.push({ name: 'Login' })
      }

      throw err
    })
}

export const put = (store, params) => {
  return api.put(params)
    .then((res) => {
      // Place a global hook here
      return res
    })
    .catch((err) => {
      // Place a gobal handler here

      // Redirect to login
      if (err.status === 403 || err.status === 401) {
        return router.push({ name: 'Login' })
      }

      throw err
    })
}

export const del = (store, params) => {
  return api.destroy(params)
    .then((res) => {
      // Place a global hook here
      return res
    })
    .catch((err) => {
      // Place a gobal handler here

      // Redirect to login
      if (err.status === 403 || err.status === 401) {
        return router.push({ name: 'Login' })
      }

      throw err
    })
}



// WEBPACK FOOTER //
// ./src/store/actions.js